import React from "react";
import { Drawer, Typography, Tag, Divider } from "antd";
import { WA } from "../theme";
import { VARIABLES_SUGERIDAS, etiquetaModelo, variablesDe, rellenar } from "./Helpers/plantillasHelpers";

const { Text, Paragraph } = Typography;

// Descripción de qué dato llena cada variable sugerida.
const DESCRIPCIONES = {
  serie_folio: "Serie y folio del documento",
  total: "Total del documento",
  subtotal: "Subtotal (sin impuestos)",
  impuestos_total: "Suma de impuestos",
  cliente: "Nombre del cliente",
  cantidad_productos: "Número de partidas/productos",
  observaciones: "Observaciones del documento",
  rfc: "RFC",
  fecha_documento: "Fecha del documento",
  fecha_actual: "Fecha de hoy",
  nombre: "Nombre / razón social",
  tipo_cliente: "Tipo de cliente",
  tipo_proveedor: "Tipo de proveedor",
  regimen_fiscal: "Régimen fiscal",
  direccion_facturacion: "Dirección de facturación",
  correo: "Correo electrónico",
  telefono: "Teléfono",
  numero: "Número de teléfono",
  descripcion: "Descripción del insumo o lead",
  descripcion_larga: "Descripción larga / detalles",
  clave: "Clave del insumo",
  codigo: "Código",
  codigo_barras: "Código de barras",
  marca: "Marca",
  tipo: "Tipo de insumo",
  familia: "Familia",
  unidad: "Unidad",
  valor: "Valor estimado del lead",
  origen: "Origen del lead",
  nombre_contacto: "Nombre del contacto asociado",
  nombre_embudo: "Nombre del embudo",
  nombre_etapa: "Etapa actual del lead",
};

// Panel lateral que explica cómo se llenan las variables y muestra un preview con ejemplos.
const GuiaLlenadoPlantilla = ({ visible, onClose, modelo, cuerpo, ejemplos = {} }) => {
  const sugeridas = (modelo && VARIABLES_SUGERIDAS[modelo]) || [];
  const usadas = variablesDe(cuerpo);
  const ejemplosPreview = {};
  usadas.forEach((n) => (ejemplosPreview[n] = ejemplos[n] || `«${n}»`));

  return (
    <Drawer
      title="Cómo se llena esta plantilla"
      placement="right"
      width={360}
      visible={visible}
      onClose={onClose}
      zIndex={1300}
    >
      <Text strong>Vista previa con datos de ejemplo</Text>
      <div
        style={{
          border: `1px solid ${WA.border}`,
          borderRadius: 8,
          padding: 10,
          marginTop: 6,
          background: WA.bg,
          whiteSpace: "pre-wrap",
        }}
      >
        {rellenar(cuerpo, ejemplosPreview) || <Text type="secondary">Escribe el cuerpo…</Text>}
      </div>

      <Divider />

      {modelo ? (
        <>
          <Text strong>Variables sugeridas para {etiquetaModelo(modelo)}</Text>
          <Paragraph type="secondary" style={{ fontSize: 12, marginTop: 4 }}>
            Al enviar, se autollenan buscando el documento. Usa exactamente estos nombres:
          </Paragraph>
          {sugeridas.map((n) => (
            <div key={n} style={{ marginBottom: 8 }}>
              <Tag color={usadas.includes(n) ? WA.turquesa : "default"}>{`{{${n}}}`}</Tag>
              <Text style={{ fontSize: 12, color: WA.textSecondary }}>{DESCRIPCIONES[n] || ""}</Text>
            </div>
          ))}
        </>
      ) : (
        <Text type="secondary">
          Asigna un modelo a la plantilla para ver sus variables sugeridas y habilitar el autollenado.
        </Text>
      )}
    </Drawer>
  );
};

export default GuiaLlenadoPlantilla;
